<app-menu-common url="sales"></app-menu-common>

<div class="pagecontent header">
  <div class="pagetitle grey" >Paramètres PS</div>
</div>

<div class="paramps-container"> bw
  <ng-container *ngIf="(paramPS$ | async) as paramPS; else loadingOrError">
  <form [formGroup]="paramPSForm" *ngIf="!errorMessage; else loadingOrError">
    <div class="param-grid">
      <div class="param-item">
        <label>Id. facturation</label>
        <span *ngIf="!isEditing">{{ paramPS.numIdentFact }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput formControlName="numIdentFact">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Code Spécialité</label>
        <span *ngIf="!isEditing">{{ paramPS.codeSpec }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput type="number" formControlName="codeSpec">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Type Émetteur</label>
        <span *ngIf="!isEditing">{{ paramPS.typeEmet }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput formControlName="typeEmet">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Numéro Émetteur</label>
        <span *ngIf="!isEditing">{{ paramPS.numEmet }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput type="number" formControlName="numEmet">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Email Facturation</label>
        <span *ngIf="!isEditing">{{ paramPS.mailFact }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput type="email" formControlName="mailFact">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>URL SMTP</label>
        <span *ngIf="!isEditing">{{ paramPS.urlSMTP }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput formControlName="urlSMTP">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Port SMTP</label>
        <span *ngIf="!isEditing">{{ paramPS.portSMTP }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput type="number" formControlName="portSMTP">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Authentification SMTP</label>
        <span *ngIf="!isEditing">{{ paramPS.authSMTP }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput type="number" formControlName="authSMTP">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>SSL SMTP</label>
        <span *ngIf="!isEditing">{{ paramPS.sslSMTP }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput type="number" formControlName="sslSMTP">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Login SMTP</label>
        <span *ngIf="!isEditing">{{ paramPS.loginSMTP }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput formControlName="loginSMTP">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Mot de passe SMTP</label>
        <span *ngIf="!isEditing">{{ paramPS.passSMTP }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput type="password" formControlName="passSMTP">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>URL POP3</label>
        <span *ngIf="!isEditing">{{ paramPS.urlPOP3 }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput formControlName="urlPOP3">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Port POP3</label>
        <span *ngIf="!isEditing">{{ paramPS.portPOP3 }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput type="number" formControlName="portPOP3">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Login POP3</label>
        <span *ngIf="!isEditing">{{ paramPS.loginPOP3 }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput formControlName="loginPOP3">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Mot de passe POP3</label>
        <span *ngIf="!isEditing">{{ paramPS.passPOP3 }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput type="password" formControlName="passPOP3">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Top Compression</label>
        <span *ngIf="!isEditing">{{ paramPS.topCompression }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput type="number" formControlName="topCompression">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Top Chiffrement</label>
        <span *ngIf="!isEditing">{{ paramPS.topChiffrement }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput type="number" formControlName="topChiffrement">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Top Affichage Diag STS</label>
        <span *ngIf="!isEditing">{{ paramPS.topAffichDiagSTS }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput type="number" formControlName="topAffichDiagSTS">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Top Désactivation STS</label>
        <span *ngIf="!isEditing">{{ paramPS.topDesactivSTS }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput type="number" formControlName="topDesactivSTS">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Top Supprimer Non SV</label>
        <span *ngIf="!isEditing">{{ paramPS.topSupprimerNonSV }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput type="number" formControlName="topSupprimerNonSV">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Nombre Max FSE par Lot</label>
        <span *ngIf="!isEditing">{{ paramPS.nbMaxFseParLot }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput type="number" formControlName="nbMaxFseParLot">
        </mat-form-field>
      </div>

      <div class="grid-break"></div>  <!-- OCT -->

      <div class="param-item">
        <label>Mode Fonctionnement OCT</label>
        <span *ngIf="!isEditing">{{ paramPS.modeFonc }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <mat-select formControlName="modeFonc">
            <mat-option value="SANS_OCT">SANS_OCT</mat-option>
            <mat-option value="OCT_ECLATEMENT_SOURCE">OCT_ECLATEMENT_SOURCE</mat-option>
            <mat-option value="OCT_FICHIER_UNIQUE">OCT_FICHIER_UNIQUE</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Numéro OCT</label>
        <span *ngIf="!isEditing">{{ paramPS.numOCT }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput formControlName="numOCT">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Type Dest. OCT</label>
        <span *ngIf="!isEditing">{{ paramPS.typeDestOCT }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput formControlName="typeDestOCT">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Aplication OCT</label>
        <span *ngIf="!isEditing">{{ paramPS.appliOCT }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput formControlName="appliOCT">
        </mat-form-field>
      </div>                        
      <div class="param-item">
        <label>e-mail OCT</label>
        <span *ngIf="!isEditing">{{ paramPS.balOCT }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput formControlName="balOCT">
        </mat-form-field>
      </div>

      <div class="grid-break"></div>  <!-- SCORE -->

      <div class="param-item">
        <label>Mode SCOR</label>
        <span *ngIf="!isEditing">{{ paramPS.modeSCOR }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <mat-select formControlName="modeSCOR">
            <mat-option value="SCOR">SCOR</mat-option>
            <mat-option value="OCT_ROUTEUR">OCT_ROUTEUR</mat-option>
            <mat-option value="OCT_DEPOSITAIRE">OCT_DEPOSITAIRE</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Type Destinataire ARL SCOR</label>
        <span *ngIf="!isEditing">{{ paramPS.typeDestinaireARLSCOR }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <mat-select formControlName="typeDestinaireARLSCOR">
            <mat-option value="PS">PS</mat-option>
            <mat-option value="OCT">OCT</mat-option>
            <mat-option value="PS_OCT">PS_OCT</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Code Région SCOR</label>
        <span *ngIf="!isEditing">{{ paramPS.codeRegionSCOR }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput type="number" formControlName="codeRegionSCOR">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Taille Max PDF SCOR (ko)</label>
        <span *ngIf="!isEditing">{{ paramPS.tailleMaxPDFSCOR }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput type="number" formControlName="tailleMaxPDFSCOR">
        </mat-form-field>
      </div>
      <div class="param-item">
        <label>Taille Max Lot SCOR</label>
        <span *ngIf="!isEditing">{{ paramPS.tailleMaxLotSCOR }}</span>
        <mat-form-field *ngIf="isEditing" appearance="outline">
          <input matInput type="number" formControlName="tailleMaxLotSCOR">
        </mat-form-field>
      </div>
    </div>
    </form>
    </ng-container>
    
    <div class="paramps-actions">
      <button mat-raised-button color="primary" *ngIf="!isEditing" (click)="toggleEditMode()">
        <mat-icon>edit</mat-icon> Modifier
      </button>
      <button mat-raised-button color="accent" *ngIf="isEditing" (click)="saveChanges()" [disabled]="paramPSForm.invalid">
        <mat-icon>save</mat-icon> Enregistrer
      </button>
      <button mat-button *ngIf="isEditing" (click)="cancelEdit()">
        <mat-icon>cancel</mat-icon> Annuler
      </button>
    </div>

  <ng-template #loadingOrError>
    <div *ngIf="errorMessage; else loading">
      <p class="error-message">{{ errorMessage }}</p>
    </div>
    <ng-template #loading>
      <p>Chargement des paramètres PS...</p>
    </ng-template>
  </ng-template>

  <ng-template #loadingOrError>
    <div *ngIf="errorMessage; else loading">
      <p class="error-message">{{ errorMessage }}</p>
    </div>
    <ng-template #loading>
      <p>Chargement des paramètres PS...</p>
    </ng-template>
  </ng-template>
</div>